import { inject, Injectable } from '@angular/core';
import { AuthenticationService, IMenuProvider, Menu, ToasterService } from '@maersk-global/angular-shared-library';
import { map, Observable, take, timer } from 'rxjs';
import { CUSTOMER_LOGOUT_SUCCESSFULLY } from '../constants/constants';
import { Customer } from '../models/payload';
import { RbacService } from './rbac.service';
import { SharedDataService } from './shared-data.service';
import { StorageService } from './storage.service';

@Injectable()
export class HeaderMenuService implements IMenuProvider {

  private storageService = inject(StorageService);
  private toasterService = inject(ToasterService);
  private sharedService = inject(SharedDataService);
  private rbacService = inject(RbacService);
  private authenticationService = inject(AuthenticationService, { optional: true });

  getMenuAsync(): Observable<Menu[]> {
    return this.sharedService.userRoleCustomers$.pipe(map(data => {
      return [
        {
          icon: 'user-circle',
          sequence: 3,
          disabled: false,
          profile: {
            displayName: data?.frInformation?.firstName + ' ' + data?.frInformation?.lastName,
            email: data?.frInformation?.email,
            subProfile: {
              role: data?.roles[0]?.roleName ?? '',
              // global admin (RBAC role ADMIN) sees all customers; feature-only admins still see their own customer(s)
              companyName: this.rbacService.isGlobalAdmin() ? ['ALL'] : data?.customers?.map((x: Customer) => x.customerName) ?? []
            },
            logout: {
              onClick: () => {
                this.storageService.clear();
                this.toasterService.showToast({
                  message: CUSTOMER_LOGOUT_SUCCESSFULLY,
                  type: 'info',
                  position: 'top-center'
                });
                timer(0).pipe(take(1)).subscribe(() => {
                  this.authenticationService?.triggerLogout();
                  this.storageService.clear();
                });
              }
            }
          },
        },
        {
          icon: 'bell',
          sequence: 2,
          disabled: true,
          title: 'Notifications'
        },
        {
          icon: 'question-circle',
          sequence: 1,
          disabled: true,
          title: 'Help & FAQ',
          subMenus: [
            {
              displayName: 'Help',
              group: 2,
              onClick: () => {
              },
              disabled: false
            },
            {
              displayName: 'Release Updates',
              trailingIcon: 'square-arrow-up-right',
              disabled: true
            },
            {
              displayName: 'Training',
              trailingIcon: 'square-arrow-up-right',
              disabled: true
            },
            {
              displayName: 'Share Feedback',
              group: 3,
              disabled: true
            },
            {
              displayName: 'Report An Issue',
              trailingIcon: 'square-arrow-up-right',
              group: 3,
              onClick: () => {
                window.open('https://maersk.service-now.com/end_user_portal?id=report_issue&sys_id=e0a0678cc34d46d491873a0c050131ce')
              },
              disabled: false
            },
          ],
        },
      ];
    }), take(2));
  }

}
